import { useRegisterSW } from 'virtual:pwa-register/react';

import { PwaUpdateBanner as UiPwaUpdateBanner } from '@kilat/ui';

import { useI18n } from '../lib/use-i18n.js';
import { logger } from '../lib/logger.js';

/**
 * Dashboard thin wrapper around the shared `<PwaUpdateBanner>`.
 * Owns the operator-mid-shift-flavoured copy + the desktop-friendly
 * bottom-right placement.
 */
export function PwaUpdateBanner() {
  const { t } = useI18n();
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(r) {
      logger.info('dashboard pwa: service worker registered', { hasReg: Boolean(r) });
    },
    onRegisterError(error) {
      logger.warn('dashboard pwa: service worker register failed', { error: String(error) });
    },
  });

  return (
    <UiPwaUpdateBanner
      needRefresh={needRefresh}
      onApply={() => void updateServiceWorker(true)}
      onDismiss={() => setNeedRefresh(false)}
      headline={t('dashboard.pwaUpdate.headline')}
      body={t('dashboard.pwaUpdate.body')}
      primaryLabel={t('dashboard.pwaUpdate.primaryLabel')}
      secondaryLabel={t('dashboard.pwaUpdate.secondaryLabel')}
      placement="bottom-right"
    />
  );
}
